import type { AllowedStatesOptions } from '@library/types/allowedStates';
import { useGetAllowedStatesQuery } from '@bo-services/allowedStatesApi';
import { useMemo } from 'react';

const allowedStatesQueryParams = { perPage: '100' };

export const usePlayerPacksExcludedStates = () => {
  const { data: response, isLoading } = useGetAllowedStatesQuery(
    allowedStatesQueryParams
  );

  const allowedStates = useMemo(() => {
    return response?.data.map((allowedState) => {
      return {
        id: allowedState.id,
        name: allowedState.attributes.name
      };
    }) as Array<AllowedStatesOptions>;
  }, [response]);

  return {
    allowedStates,
    isLoadingStates: isLoading
  };
};
